import { createComponent } from '@carvana/merch-components';
import type {
  IntersectionObserverProps,
  PlainChildrenProps
} from 'react-intersection-observer';
import { InView } from 'react-intersection-observer';

export const Wrapper = createComponent('div', {
  className: 'grid justify-items-end gap-y-4'
});

export const SubPrice = createComponent('div', {
  className: 'text-blue-7 tl-body-s m:tl-body-m'
});

export const Price = createComponent('p', {
  className:
    'text-[18px] font-bold leading-none text-blue-7 m:text-[36px] m:leading-8',
  'data-qa': 'hero-header-price'
});

export const OriginalPrice = createComponent('div', {
  className: 'flex w-fit text-grey-5 line-through tl-body-xs m:tl-body-s',
  'data-qa': 'hero-header-og-price'
});

export const TradeIncentiveCopy = createComponent<
  IntersectionObserverProps | PlainChildrenProps
>(InView, {
  as: 'div',
  className:
    'grid auto-cols-max grid-flow-col items-center gap-x-8 text-green-3 tl-body-s'
});
